import Vue from "vue";
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload);
const loadimage = require("@/assets/loading.svg");
const errorimage = require("@/assets/error.png");
// or with options
Vue.use(VueLazyload, {
  lazyComponent: true,
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1,
});
